import React from "react";

export default function WatchTrailer(props) {
  return (
    <div
      className={`modal videoPopup full-screen-video ${
        props?.open !== null ? "show" : "fade"
      }`}
      id="videoModal"
      tabIndex="-1"
      aria-labelledby="expireLabel"
      aria-hidden="true"
      style={{ display: props?.open !== null ? "block" : "none" }}
    >
      <div className="modal-dialog modal-fullscreen">
        <div className="modal-content">
          <button
            className="close btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
            onClick={() => props.setOpen(null, false)}
          ></button>
          <div className="vdContent">
            <video className="bg" autoPlay={true}>
              <source
                src={props.videoURL}
                type="video/mp4"
              />
            </video>
          </div>
        </div>
      </div>
    </div>
  );
}
